/**
 * @todo Удалить файл
 * @description Данный функционал появился в задаче CD-243382, будет удалён в задаче CD-245101
 * Не забудь удалить Marech.NewbuildingBuzzoolaIntegrationTestWeb.Enabled,
 * Marech.NewbuildingBuzzoolaIntegrationAsStub.Enabled,
 * Marech.NewbuildingBuzzoolaIntegrationTestWeb.TGB.AllowedRegions,
 * Marech.NewbuildingBuzzoolaFirst.Enabled из src/node/scheme.json
 * Если переходим на базуллу, то удаляем библиотеки адфокса @cian/adfox-component, @cian/adfox-templates, @cian/postview-analytics-utils
 * Если остаёмся на адфоксе, то удаляем библиотеку базуллы @cian/buzzoola-component
 */

import { useSelector } from 'react-redux';

import { useApplicationContext } from 'shared/containers/ApplicationContext';
import { abUseExperimentsSelector } from 'shared/selectors/abUseExperiments';
import { regionIdSelector } from 'shared/selectors/offerData/geo/regionIdSelector';
import { isAbUseExperimentGroup } from 'shared/utils/isAbUseExperimentGroup';

export const NEWBUILDING_BUZZOLA_INTEGRATION_TEST_WEB = 'newbuilding_buzzoola_integration_test_web';

export function useNewbuildingBuzzoolaIntegrationTestWebBuzzoolaGroup(): boolean {
  const { config } = useApplicationContext();
  const experiments = useSelector(abUseExperimentsSelector);

  const regionId = useSelector(regionIdSelector);

  const enabled = useNewbuildingBuzzoolaIntegrationTestWebExpEnabled();

  const allowedRegions = config.get<number[]>('Marech.NewbuildingBuzzoolaIntegrationTestWeb.TGB.AllowedRegions');
  const isBuzzoolaGroup = isAbUseExperimentGroup(experiments, NEWBUILDING_BUZZOLA_INTEGRATION_TEST_WEB, 'Buzzoola');

  if (enabled && Array.isArray(allowedRegions) && isBuzzoolaGroup) {
    if (allowedRegions.length === 0) {
      return true;
    }

    return allowedRegions.includes(regionId);
  }

  return false;
}
/**
 * @description Проверяет, включен ли фича-тоггл для эксперимента тестирования интеграции с базуллой
 */
export function useNewbuildingBuzzoolaIntegrationTestWebExpEnabled(): boolean {
  const { config } = useApplicationContext();

  return !!config.get<boolean>('Marech.NewbuildingBuzzoolaIntegrationTestWeb.Enabled');
}

/**
 * @description Проверяет, включен ли фича-тоггл для запроса базуллы при стабе адфокса
 */
export function useNewbuildingBuzzoolaIntegrationAsStubEnabled(): boolean {
  const { config } = useApplicationContext();

  return !!config.get<boolean>('Marech.NewbuildingBuzzoolaIntegrationAsStub.Enabled');
}

/**
 * @description Проверяет, включен ли фича-тоггл для запроса базуллы вместо адфокса
 */
export function useNewbuildingBuzzoolaFirstEnabled(): boolean {
  const { config } = useApplicationContext();

  return !!config.get<boolean>('Marech.NewbuildingBuzzoolaFirst.Enabled');
}
